module.exports = __webpack_public_path__ + "img/cy.a0e181c3.svg";